import { useMemo } from 'react';

import { useStoredValueProgramsQuery } from '@occc/graphql';

import { findStoredValueProgramByDiscountingOfferId } from './stored-value-update-by-offer-page.utils';

const STORED_VALUE_PROGRAMS_LOOKUP_PAGE_SIZE = 100;

type UseGetStoredValueProgramByDiscountingOfferIdParams = {
  offerId: string | undefined;
  chainId: string | undefined;
};

export const useGetStoredValueProgramByDiscountingOfferId = ({
  offerId,
  chainId,
}: UseGetStoredValueProgramByDiscountingOfferIdParams) => {
  const response = useStoredValueProgramsQuery({
    variables: {
      filter: chainId ? { chainIdEquals: chainId } : undefined,
      first: STORED_VALUE_PROGRAMS_LOOKUP_PAGE_SIZE,
    },
    skip: !offerId || !chainId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const program = useMemo(() => {
    if (!offerId) {
      return undefined;
    }

    const programs = response.data?.storedValuePrograms.edges.map((edge) => edge.node) ?? [];

    return findStoredValueProgramByDiscountingOfferId(programs, offerId);
  }, [offerId, response.data]);

  return {
    ...response,
    data: program,
  };
};
